<template>
  <div>
    <nav-bar />
    <v-container fluid>
      <v-row align-content="space-around">
        <v-col cols="12">
          <v-card outlined>
            <v-card-title> FOTA </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form v-model="vaildationCheck" ref="form">
                <v-row>
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-radio-group
                      row
                      v-model="deviceType"
                      label="Device Type : "
                      :rules="rules"
                    >
                      <v-radio label="Ecotron" value="ecotron"></v-radio>
                      <v-radio label="Ecofrost" value="ecofrost"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="pt-0 pb-0">
                    <v-radio-group
                      row
                      v-model="controllerType"
                      label="Controller : "
                      :rules="rules"
                      :disabled="controllerRadioGroup"
                    >
                      <v-radio label="M66" value="m66"></v-radio>
                      <v-radio label="PIC" value="pic"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-if="deviceType === 'ecofrost'">
                  <v-col cols="12">
                    <v-file-input
                      label="Select Hex/Bin File for Ecofrost FOTA"
                      :accept="typeOfFile"
                      clearable
                      controllers
                      show-size
                      v-model="files"
                      outlined
                      rounded
                      prepend-icon=""
                      prepend-inner-icon="mdi-file-code"
                      placeholder=" "
                      :rules="rules"
                      :disabled="disableFile"
                    />
                  </v-col>
                </v-row>
                <v-row v-else-if="deviceType === 'ecotron'">
                  <v-col cols="10">
                    <v-file-input
                      label="Select Bin File for Ecotrin FOTA"
                      accept=".bin"
                      clearable
                      controllers
                      show-size
                      v-model="ecotoronFiles"
                      outlined
                      rounded
                      prepend-icon=""
                      prepend-inner-icon="mdi-file-code"
                      placeholder=" "
                      :success-messages="ecotronUploadMessage"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-btn
                      color="primary"
                      fab
                      :disabled="ecotronFotaUpload"
                      @click="uploadEcotronFota"
                      :loading="uploadEcotronFotaLoading"
                    >
                      <v-icon>mdi-upload</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      label="Ecotron FOTA Version"
                      outlined
                      rounded
                      placeholder=" "
                      :items="listOfEcotronVersions"
                      :disabled="ecotronFotaVerisonDisabled"
                      :rules="rules"
                      v-model="ecotronFotaVersion"
                    >
                    </v-select>
                  </v-col>
                </v-row>

                <v-row align-content="center" justify="center">
                  <v-col cols="12" align-self="center">
                    <v-textarea
                      outlined
                      label="Device Serial Numbers"
                      placeholder="Comma Seperated Serial Numbers Eg: EZMCI19120358,EZMCI19120359,EZMCI19120360"
                      auto-grow
                      :rules="rules"
                      v-model="listOfDeviceIds"
                      :disabled="listDisabled"
                      rounded
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                @click="executeFota"
                :loading="loading"
                :disabled="executeFotaDisable"
              >
                <v-icon left>mdi-powershell</v-icon>
                Start FOTA
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row align-content="space-around">
        <v-col cols="12">
          <v-card outlined>
            <v-card-title> FOTA Result </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-radio-group
                    row
                    v-model="resultDeviceType"
                    label="Device Type : "
                  >
                    <v-radio label="Ecotron" value="ecotron"></v-radio>
                    <v-radio label="Ecofrost" value="ecofrost"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="resultDeviceType">
                <v-col cols="12">
                  <v-card outlined>
                    <v-data-table :headers="headers" :items="items">
                      <template
                        #[`item.Topic`]="{ item }"
                        v-if="resultDeviceType === 'ecotron'"
                      >
                        <v-chip :color="getColour(item)" dark>{{
                          item.Topic
                        }}</v-chip>
                      </template>
                      <template
                        #[`item.actions`]="{ item }"
                        v-if="resultDeviceType === 'ecofrost'"
                      >
                        <v-btn
                          @click="resendFota(item)"
                          fab
                          color="primary"
                          small
                          class="ml-3"
                          ref="resendFotaButton"
                          :loading="item.loading"
                        >
                          <v-icon> mdi-restore </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :loading="resultLoading"
                @click="refreshResult"
                :disabled="refreshDisable"
              >
                <v-icon left>mdi-restore</v-icon>
                Refresh
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { nodeRestApi } from '../plugins/api';
import { format } from 'highcharts';
import NavBar from '../components/NavBar';
import moment from 'moment';
import axios from 'axios';
export default {
  name: 'fota',
  components: { NavBar },
  data() {
    return {
      rules: [value => !!value || 'Required'],
      vaildationCheck: true,
      listOfDeviceIds: '',
      listDisabled: true,
      loading: false,
      deviceType: null,
      controllerType: null,
      controllerRadioGroup: true,
      files: null,
      typeOfFile: null,
      disableFile: true,
      resultDeviceType: null,
      resultLoading: false,
      items: [],
      refreshDisable: true,
      listOfEcotronVersions: [],
      ecotronFotaVerisonDisabled: false,
      ecotronFotaVersion: '',
      ecotoronFiles: null,
      ecotronFotaUpload: true,
      uploadEcotronFotaLoading: false,
      ecotronUploadMessage: [],
      executeFotaDisable: false
    };
  },
  computed: {
    headers() {
      if (this.resultDeviceType === 'ecotron') {
        return [
          {
            text: 'Serial No.',
            value: 'Topic'
          },
          {
            text: 'Expected Ecotron s/w version',
            value: 'expectedFotaVersion'
          },
          {
            text: 'FOTA Timestamp',
            value: 'fotaTimestamp'
          },
          {
            text: 'Current Ecotron s/w version',
            value: 'ET_SWV'
          },
          {
            text: 'Last Update Timestamp',
            value: 'updatedAt'
          }
        ];
      } else if (this.resultDeviceType === 'ecofrost') {
        return [
          {
            text: 'Serial No.',
            value: 'Topic'
          },
          {
            text: 'M66 s/w version',
            value: 'M66_ASV'
          },
          {
            text: 'PIC s/w version',
            value: 'PIC32_Sv'
          },
          {
            text: 'M66 FOTA Timestamp',
            value: 'm66FotaTimestamp'
          },
          {
            text: 'PIC FOTA Timestamp',
            value: 'picFotaTimestamp'
          },
          {
            text: 'Last Update Timestamp',
            value: 'updatedAt'
          },
          {
            text: 'Resend FOTA Command',
            value: 'actions',
            sortable: false
          }
        ];
      } else {
        return [];
      }
    }
  },
  watch: {
    deviceType(payload) {
      if (payload === 'ecofrost') {
        this.controllerRadioGroup = false;
        this.resultDeviceType = payload;
      } else if (payload === 'ecotron') {
        this.controllerType = 'm66';
        this.controllerRadioGroup = true;
        this.ecotronFotaVersionDisabled = false;
        this.resultDeviceType = payload;
      }
    },
    controllerType(payload) {
      if (payload === 'm66') {
        this.typeOfFile = '.bin';
      } else if (payload === 'pic') {
        this.typeOfFile = '.hex';
      }
      this.disableFile = false;
    },
    files(payload) {
      if (payload === undefined) {
        this.listDisabled = true;
      } else {
        this.listDisabled = false;
      }
    },
    ecotronFotaVersion(payload) {
      if (payload === '') {
        this.listDisabled = true;
      } else {
        this.listDisabled = false;
      }
    },
    resultDeviceType(payload) {
      this.items = [];
      this.refreshDisable = false;
    },
    ecotoronFiles(payload) {
      if (payload === undefined) {
        this.ecotronFotaUpload = true;
      } else {
        this.ecotronFotaUpload = false;
      }
    },
    ecotronUploadMessage(payload) {
      if (Array.isArray(payload)) {
        if (payload.length > 0) {
          setTimeout(() => {
            this.ecotronUploadMessage = [];
          }, 5000);
        }
      }
    }
  },
  methods: {
    async executeFota() {
      if (this.$refs.form.validate()) {
        this.$store.commit('setError', false);
        this.loading = true;
        try {
          let nodeResponse;
          if (this.deviceType === 'ecotron') {
            nodeResponse = await nodeRestApi({
              method: 'POST',
              url: '/ecotron/fota',
              data: {
                listOfDeviceIds: this.listOfDeviceIds.split(','),
                controllerType: this.controllerType,
                ecotronFotaVersion: this.ecotronFotaVersion
              },
              headers: {
                'Content-Type': 'application/json'
              }
            });
          } else if (this.deviceType === 'ecofrost') {
            let formData = new FormData();
            formData.append('listOfDeviceIds', this.listOfDeviceIds);
            formData.append('controllerType', this.controllerType);
            formData.append('file', this.files);
            nodeResponse = await nodeRestApi({
              method: 'POST',
              url: '/ecofrost/fota',
              data: formData,
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
          }
          if (nodeResponse.status === 201) {
            await this.refreshResult();
          } else {
            throw new Error('Error executing FOTA');
          }
        } catch (error) {
          if (error.isAxiosError) {
            this.$store.commit('setError', error.response.data.error.message);
          } else {
            this.$store.commit('setError', error);
          }
        } finally {
          this.loading = false;
          this.executeFotaDisable = true;
        }
      }
    },
    async refreshResult() {
      this.resultLoading = true;
      this.items = [];
      this.$store.commit('setError', false);

      try {
        const nodeResponse = await nodeRestApi({
          method: 'GET',
          url: `/${this.resultDeviceType}/fota`,
          params: {
            timestamp: new Date().toISOString()
          }
        });
        this.items = nodeResponse.data.map(el => {
          return {
            ...el,
            loading: false
          };
        });
      } catch (error) {
        if (error.isAxiosError) {
          this.$store.commit('setError', error.response.data.error.message);
        } else {
          this.$store.commit('setError', error);
        }
      } finally {
        this.resultLoading = false;
      }
    },
    async uploadEcotronFota() {
      this.$store.commit('setError', false);
      try {
        this.uploadEcotronFotaLoading = true;
        let formData = new FormData();
        formData.append('file', this.ecotoronFiles);
        const response = await nodeRestApi({
          method: 'POST',
          url: '/ecotron/fota/versions',
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        await this.getEcotronVersionList();
        this.ecotronUploadMessage.push(
          `${this.ecotoronFiles.name} uploaded successfully`
        );
      } catch (error) {
        if (error.isAxiosError) {
          this.$store.commit('setError', error.response.data.error.message);
        } else {
          this.$store.commit('setError', error);
        }
      } finally {
        this.uploadEcotronFotaLoading = false;
        this.ecotronFotaVerisonDisabled = false;
        this.ecotoronFiles = null;
      }
    },
    async getEcotronVersionList() {
      try {
        this.$store.commit('setError', false);
        const response = await nodeRestApi.get('/ecotron/fota/versions');
        if (Array.isArray(response.data)) {
          if (response.data.length > 0) {
            this.listOfEcotronVersions = response.data.map(element => {
              return {
                text: element,
                value: element
              };
            });
          } else {
            this.ecotronFotaVerisonDisabled = true;
            throw new Error('No Ecotron FOTA versions available on the server');
          }
        } else {
          this.ecotronFotaVerisonDisabled = true;
          throw new Error('Error parsing Ecotron FOTA versions');
        }
      } catch (error) {
        if (error.isAxiosError) {
          this.$store.commit('setError', error.response.data.error.message);
        } else {
          this.$store.commit('setError', error);
        }
      }
    },
    getColour(ecotron) {
      if (ecotron.expectedFotaVersion === ecotron.ET_SWV) {
        return 'primary';
      } else {
        if (ecotron.updateAt !== 'NA') {
          let timeDiff = moment(
            moment(ecotron.updatedAt, 'DD/MM/YY HH:mm:ss')
          ).diff(moment(ecotron.fotaTimestamp, 'DD/MM/YY HH:mm:ss'), 'minute');
          if (Math.abs(timeDiff) >= 10) {
            return 'error';
          } else {
            let currentTimeDiff = moment(moment()).diff(
              moment(ecotron.fotaTimestamp, 'DD/MM/YY HH:mm:ss'),
              'minute'
            );
            if (Math.abs(currentTimeDiff) >= 10) {
              return 'error';
            } else {
              return 'warning';
            }
          }
        } else {
          return 'error';
        }
      }
    },
    async resendFota(payload) {
      payload.loading = true;
      this.$store.commit('setError', false);
      try {
        const mqttApi = axios.create({
          baseURL: 'https://api.ecozen.ai/mqtt/v1',
          url: `/EF/${payload.Topic}`
        });
        if (payload.m66FotaTimestamp !== 'N/A') {
          await mqttApi({
            method: 'POST',
            data: {
              command: '0110007F00010102545D'
            }
          });
        }

        if (payload.picFotaTimestamp !== 'N/A') {
          await mqttApi({
            method: 'POST',
            data: {
              command: '0110007F00010101145C'
            }
          });
        }
      } catch (error) {
        if (error.isAxiosError) {
          this.$store.commit('setError', error.response.data.error.message);
        } else {
          this.$store.commit('setError', error);
        }
      } finally {
        payload.loading = false;
      }
    }
  },
  async created() {
    this.executeFotaDisable = false;
    await this.getEcotronVersionList();
  }
};
</script>
